import {
  ExternalTransaction,
  ExternalTransactionStatus,
} from '@helios/common-api'
import { InventoryType } from '../inventory-type.model'
import { SecurityInfo } from './bulk-misc-model'
import { BulkTransaction } from './bulk-transaction'
import { HeliosServerSideRequest } from '@helios/server-side-util'
import {
  Position,
  PositionsRequestContext,
} from './bulk-transfer-out-all-positions-model'

export enum BulkTransactionModalMode {
  CreateCWTran,
  EditCWTran,
  CreateFromExtTran,
  CreateFromPosition,
  CopyCWTran,
}

export interface BulkTransactionModalInput {
  modalMode: BulkTransactionModalMode
  enterPrediction?: BulkTransaction[]
  transactions?: BulkTransaction[]
  cwTranId?: string[]
  securityId?: number[]
  securityData?: SecurityInfo[]
  extTranId?: number[]
  externalTransaction?: ExternalTransaction[]
  bulkStatus?: Map<number, ExternalTransactionStatus | undefined>
  isFromDistriBution?: boolean
  note?: string
  positionData?: BulkTransferPositionData[]
  transferAllPositionsRequest?: HeliosServerSideRequest<
    Position,
    PositionsRequestContext
  >

  isTwoSidedTrno?: boolean
}

export interface BulkTransferPositionData {
  sessionReconDate: string
  assetId: string
  accountId: number
  units: number
  inventoryType?: InventoryType
  collateralBroker?: string
}
